var map = {
	"./coins-0.png": 2380,
	"./coins-119.png": 8635,
	"./coins-139.png": 6177,
	"./coins-22.png": 9390,
	"./coins-47.png": 2581,
	"./coins-83.png": 7525
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7670;